import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-state--Finished",
  "use": "icon-state--Finished-usage",
  "viewBox": "0 0 52.34 59.33",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 52.34 59.33\" id=\"icon-state--Finished\">\n<g id=\"icon-state--Finished_state--finished\">\n\t<polygon style=\"fill:#82B4E1;\" points=\"33.81,7.19 31.03,0 6.49,0 0,0 0,34.6 0,59.33 6.49,59.33 6.49,34.6 25.59,34.6 \n\t\t28.37,41.79 52.34,41.79 52.34,7.19 \t\" />\n</g>\n<g id=\"icon-state--Finished_Layer_1\">\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol